import React, { useState, useEffect } from "react";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  Button,
  Label,
  Input,
} from "reactstrap";
import Flatpickr from "react-flatpickr";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import Widget from "./Widgets";
import PreviewCardHeader from "../../Components/Common/PreviewCardHeader";
import ForeCastPreviewCardHeader from "../../Components/Common/ForeCastPreviewCardHeader";
import ServerPerformance from "../ServerPerformance/ServerPerformance";
import { Line, LineColumnArea } from "./MixedCharts";
import BestSellingProducts from "./BestSellingProducts";
import UiContent from "../../Components/Common/UiContent";
import { getKIPWidgetData } from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../Components/Common/Loader";
import { ColorRange } from "./HeatmapCharts";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import { POST_KPI_DASHBOARD } from "../../helpers/data_helper";
import {
  getDateByName,
  displayDate,
  convertDateFormate,
} from "../../helpers/api_helper";
import CustomDatePicker from "../../Components/Common/CustomDatePicker";
import { POST_MENU_OPTIMIZATION } from "../../helpers/data_helper";
import NewWidget from "./NewWidget";
import OverallWidget from "./OverallWidget";
import LocationWidget from "./LocationWidget";

const DashboardEcommerce = () => {
  const dispatch = useDispatch();
  document.title = "KPI Dashboard | " + process.env.REACT_APP_NAME;
  const [defaultCourse, setDefaultCourse] = useState(0);
  const [leftCustomDate, setLeftCustomDate] = useState([]);
  const [leftFilter, setLeftFilter] = useState({
    label: "Yesterday",
    value: "Yesterday",
  });
  const [rightFilter, setRightFilter] = useState({
    label: "This Month",
    value: "ThisMonth",
  });
  const [rightFilterToggle, setRightFilterToggle] = useState(false);
  const [mealPeriod, setMealPeriod] = useState(0);
  const [ordersTime, setOrdersTime] = useState(false);
  const [comparisonDate, setComparisonDate] = useState([]);
  const [ordersTimeComparison, setOrdersTimeComparison] = useState([]);
  const [filtermealperiod, setFiltermealperiod] = useState([]);
  const [forecastBudget, setForecastBudget] = useState(false);
  const [variance, setVariance] = useState("percentage");
  const [filterVariance, setFilterVariance] = useState("");
  const [forecastLastYear, setForecastLastYear] = useState(false);
  const [currency, setCurrency] = useState("$");
  const [selectedCourse, setSelectedCourse] = useState(null);

  //const [forecastHeatmapAjax, setForecastHeatmapAjax] = useState(true);
  //const [forecastHeatmapData, setForecastHeatmapData] = useState({table:[],seat:[]});

  /***********************************************/

  /*const [menuItemAjax, setMenuItemAjax] = useState(true);
  const [foodTribeAjax, setFoodTribeAjax] = useState(true);
  const [foodTribeData, setFoodTribeData] = useState({
    Covers: [],
    AvgCheck: [],
    CourseName: [],
  });*/
  /**********************************************/

  /*
  const [forecastAjax, setForecastAjax] = useState(true);
  const [forecastData, setForecastData] = useState({
      revenue:[],
      covers:[],
      revenue_cp:[],
      covers_cp:[],
      seat_occupancy:[],
      seat_occupancy_cp:[],
      average_check:[],
      average_check_cp:[],
      revPASH:[],
      revPASH_cp:[],
      revenue_max:0,
      covers_max:0,
      seat_occupancy_max:0,
      average_check_max:0,
      revPASH_max:0,
  });*/
  const [refresh, setRefresh] = useState(false);

  const { currentOutlet } = useSelector((state) => ({
    currentOutlet: state.UserOutletGroup.currentOutlet,
  }));

  const changeDefaultComparison = (item) => {
    if (item.value !== "Custom") {
      setRightFilterToggle(false);
    }
    setRightFilter(item);
  };
  const changeLeftFilter = (value) => {
    setLeftFilter(value);
  };
  const changeMealPeriod = (value) => {
    setMealPeriod(value);
  };

  const changeVariance = (value) => {
    setVariance(value);
  };

  useEffect(() => {
    if (currentOutlet?.currency !== "") {
      setCurrency(currentOutlet?.currency);
    }
  }, [currentOutlet]);

  const { filterData, filterAjax, widgetData, widgetAjax } = useSelector(
    (state) => ({
      filterData: state.Dashboard.filterData,
      filterAjax: state.Dashboard.filterAjax,
      widgetData: state.Dashboard.widgetData,
      widgetAjax: state.Dashboard.widgetAjax,
    })
  );
  useEffect(() => {
    if (filterData.date) {
      setOrdersTime(filterData.date);
    }
    if (filterData.date_compare) {
      setOrdersTimeComparison(filterData.date_compare);
    }
    if (filterData.mealperiod) {
      setFiltermealperiod(filterData.mealperiod);
    }
    if (filterData.variance) {
      setFilterVariance(filterData.variance);
    }
  }, [filterAjax, filterData]);

  // useEffect(() => {
  //   localStorage.setItem('Selling_items_SortType', '');
  //   localStorage.setItem('Reccomendation_SortType', '');
  //   if(leftFilter.value!=='Custom' || (leftFilter.value==='Custom' && leftCustomDate[0] && leftCustomDate[1]) || refresh){

  //   console.log("aaaaa",rightFilter);
  //     dispatch(
  //       getKIPWidgetData({
  //         leftFilter: leftFilter.value==='Custom'?{from:convertDateFormate(leftCustomDate[0]),to:convertDateFormate(leftCustomDate[1])}:getDateByName(leftFilter.value),
  //         rightFilter: rightFilter.value==='Custom'?{from:convertDateFormate(comparisonDate[0]),to:convertDateFormate(comparisonDate[1])}:getDateByName(rightFilter.value),
  //         mealPeriod: mealPeriod,
  //         recalculate: refresh,
  //       })
  //     );
  //   }
  // }, [leftFilter,leftCustomDate, rightFilter, mealPeriod,comparisonDate, refresh,  dispatch]);

  // useEffect(() => {
  //   postDataAPI({serviceName:POST_KPI_DASHBOARD.serviceName,op:POST_KPI_DASHBOARD.forecast_heatmap_op,mealPeriod: mealPeriod,}).then(response => {
  //     setForecastHeatmapAjax(false);
  //     if(response.status==='ok'){
  //       setForecastHeatmapData(response.data);
  //     }else{
  //       console.log(response);
  //     }
  //   });

  //   postDataAPI({serviceName:POST_KPI_DASHBOARD.serviceName,op:POST_KPI_DASHBOARD.forecast_op,mealPeriod: mealPeriod,}).then(response => {
  //     setForecastAjax(false)
  //     if(response.status==='ok'){
  //       setForecastData(response.data);
  //     }else{
  //       console.log(response);
  //     }
  //   });

  // }, [mealPeriod]);

  /*
  useEffect(() => {
    if (
      (leftFilter.value !== "Custom" ||
        (leftFilter.value === "Custom" &&
          leftCustomDate[0] &&
          leftCustomDate[1])) &&
      (rightFilter.value !== "Custom" ||
        (rightFilter.value === "Custom" &&
          comparisonDate[0] &&
          comparisonDate[1]))
    ) {
      let leftFilterData =
        leftFilter.value === "Custom"
          ? {
              from: convertDateFormate(leftCustomDate[0]),
              to: convertDateFormate(leftCustomDate[1]),
            }
          : getDateByName(leftFilter.value);
      let rightFilterData =
        activeComparisonData && activeComparisonData.datepiker
          ? {
              from: convertDateFormate(comparisonDate[0]),
              to: convertDateFormate(comparisonDate[1]),
            }
          : getDateByName(rightFilter.value);
          
      postDataAPI({
        leftFilter: leftFilterData,
        rightFilter: rightFilterData,
        mealPeriod: mealPeriod,
        course: defaultCourse,
        variance:variance
        serviceName: POST_MENU_OPTIMIZATION.serviceName,
        op: POST_MENU_OPTIMIZATION.food_tribes_op,
      }).then((response) => {
        setFoodTribeAjax(false);
        if (response.status === "ok") {
          setFoodTribeData(response.data);
        } else {
          console.log(response);
        }
      });
    }
  }, [
    variance,
    leftFilter,
    rightFilter,
    mealPeriod,
    comparisonDate,
    activeComparisonData,
    leftCustomDate,
    defaultCourse,
  ]);*/

  const handelForecastBudget = () => {
    setForecastBudget(!forecastBudget);
  };
  const handelForecastLastYear = () => {
    setForecastLastYear(!forecastLastYear);
  };
  const handleRefresh = () => {
    // setRecalculate(!recalculate);
    setRefresh(!refresh);
  };
  let date = new Date();
  date.setDate(date.getDate() - 1);
  return (
    <React.Fragment>
      <UiContent />
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Playground"
            pageTitle="Dashboard"
            activeDate={leftFilter}
            customDate={leftCustomDate}
            leftFilter={leftFilter}
            rightFilter={rightFilter}
            comparisonDate={comparisonDate}
            mealPeriod={mealPeriod}
            refresh={refresh}
            showAlert={true}
            handleRefresh={handleRefresh}
            course={
              selectedCourse?.length
                ? selectedCourse.map((c) => c.value)
                : defaultCourse
            }
          />

          <form className="mb-3">
            <Row>
              <Col className="mb-2 mb-lg-0" sm={12} lg={4}>
                <CustomDatePicker
                  activeDate={leftFilter}
                  setActiveDate={setLeftFilter}
                  customDate={leftCustomDate}
                  setCustomDate={setLeftCustomDate}
                  posEnd={false}
                />
              </Col>
              {/* <Col className="mb-2 mb-lg-0" sm={12} lg={4}>
                <UncontrolledDropdown
                  isOpen={rightFilterToggle}
                  toggle={() => {
                    setRightFilterToggle(!rightFilterToggle);
                  }}
                >
                  <DropdownToggle
                    type="button"
                    tag="button"
                    className="btn btn-outline-custom"
                  >
                    {rightFilter
                      ? rightFilter.label +
                        (rightFilter.label === "Custom"
                          ? displayDate(comparisonDate)
                          : "")
                      : "Select Comparison"}
                    <span className="rightBox">
                      <span></span>
                      <svg
                        height="20"
                        width="20"
                        viewBox="0 0 20 20"
                        aria-hidden="true"
                        focusable="false"
                        className="css-tj5bde-Svg"
                      >
                        <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
                      </svg>
                    </span>
                  </DropdownToggle>
                  <DropdownMenu className="custom-menu-width" end={true}>
                    <Row>
                      <Col sm={rightFilter ? 4 : 12}>
                        {!filterAjax &&
                          ordersTimeComparison.length > 0 &&
                          ordersTimeComparison.map((item) => {
                            return (
                              <button
                                key={item.value}
                                onClick={() => changeDefaultComparison(item)}
                                type="button"
                                tabIndex="0"
                                role="menuitem"
                                className="dropdown-item"
                              >
                                {item.label}
                              </button>
                            );
                          })}
                      </Col>
                      {rightFilter && rightFilter.label == "Custom" && (
                        <Col sm={8}>
                          <Flatpickr
                            className="form-control border-0 dash-filter-picker shadow mw-auto"
                            placeholder=""
                            value={comparisonDate}
                            onChange={([date, date2]) => {
                              if (date !== undefined && date2 !== undefined) {
                                setRightFilterToggle(false);
                              }
                              setComparisonDate([date, date2]);
                            }}
                            options={{
                              mode: "range",
                              dateFormat: "d M, Y",
                              inline: true,
                            }}
                          />
                        </Col>
                      )}
                    </Row>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Col> */}
              <Col sm={12} lg={4}>
                <select
                  className="form-select"
                  value={mealPeriod}
                  id="mealPeriod"
                  onChange={(event) => changeMealPeriod(event.target.value)}
                >
                  <option value="0">All Meal Periods</option>
                  {!filterAjax &&
                    filtermealperiod.length > 0 &&
                    filtermealperiod.map((item) => {
                      return (
                        <option key={item.sp_id} value={item.sp_id}>
                          {item.title +
                            " (" +
                            item.start_time +
                            " To " +
                            item.end_time +
                            ")"}
                        </option>
                      );
                    })}
                </select>
              </Col>
              <Col className="mb-2 mb-lg-0" sm={12} lg={4}>
                <div className="justify-content-end d-flex align-items-center gap-3">
                  <div className="form-check form-switch form-switch-right form-switch-md d-flex align-items-center gap-2">
                    <Label
                      className="form-label text-muted mb-0"
                      style={{ marginRight: "5px" }}
                    >
                      Percentage
                    </Label>
                    <Input
                      className="form-check-input"
                      type="checkbox"
                      checked={variance === "value"}
                      onChange={() =>
                        changeVariance(
                          variance === "percentage" ? "value" : "percentage"
                        )
                      }
                    />
                    <Label className="form-label text-muted mb-0 ms-2">
                      Value
                    </Label>
                  </div>
                </div>
              </Col>
            </Row>
          </form>

          <Row>
            <Col>
              <div className="h-100">
                <Col xl={12}>
                  <NewWidget
                    rightFilter={rightFilter}
                    comparisonDate={comparisonDate}
                    leftFilter={leftFilter}
                    leftCustomDate={leftCustomDate}
                    refresh={refresh}
                    mealPeriod={mealPeriod}
                    variance={variance}
                  />
                </Col>

                <Row>
                  <Col xl={12}>
                    <ServerPerformance
                      currency={currency}
                      showGraph={true}
                      server_id={0}
                      activeDate={leftFilter}
                      customDate={leftCustomDate}
                      recalculate={refresh}
                      mealPeriod={mealPeriod}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xl={12}>
                    <BestSellingProducts
                      currency={currency}
                      comparisonDate={comparisonDate}
                      activeComparisonData={false}
                      globalDate={leftFilter}
                      rightFilter={rightFilter}
                      globalCustomDate={leftCustomDate}
                      mealPeriod={mealPeriod}
                      defaultCourse={0}
                      selectedCourse={selectedCourse}
                      setSelectedCourse={setSelectedCourse}
                      recalculate={refresh}
                    />
                  </Col>
                </Row>

                {/* <Col xl={12}>
                    <OverallWidget rightFilter={rightFilter} comparisonDate={comparisonDate} leftFilter={leftFilter} leftCustomDate={leftCustomDate} refresh={refresh} mealPeriod={mealPeriod} />
                </Col>
                <Col xl={12}>
                    <LocationWidget rightFilter={rightFilter} comparisonDate={comparisonDate} leftFilter={leftFilter} leftCustomDate={leftCustomDate} refresh={refresh} mealPeriod={mealPeriod} />
                </Col> */}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DashboardEcommerce;
